import clsx from 'clsx';
import { ReactNode, useMemo } from 'react';

import style from './stepContainer.module.css';

export interface StepContainerProps {
  title?: string;
  children: ReactNode | ReactNode[];
  horizontalPadding?: string;
}

export const StepContainer = ({ title, horizontalPadding, children }: StepContainerProps) => {
  const titleComponent = useMemo(
    () =>
      !title || title.length === 0 ? null : (
        <h2
          className={clsx(style.header)}
          style={horizontalPadding ? { paddingLeft: horizontalPadding, paddingRight: horizontalPadding } : undefined}
        >
          {title}
        </h2>
      ),
    [horizontalPadding, title]
  );

  return (
    <div className={clsx(style.root)}>
      {titleComponent}
      {children}
    </div>
  );
};

export default StepContainer;
